import { object } from 'prop-types'
import { useNavigate } from 'react-router'
import { ROLE_PUBLIC } from '@router/Routes'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import Div from '@ui/layout/Div'
import Buttons from '@ui/elements/Buttons'
import useHtmlRenderer from '@hook/useHtmlRenderer'
import { useEffect } from 'react'

const ValidationPage = () => {
  const { validationPage } = useSelector(state => state.main)
  const { title, description } = validationPage || {}
  const renderHtml = useHtmlRenderer()
  const [t] = useTranslation('common')
  const navigate = useNavigate()

  useEffect(() => {
    if (null === validationPage || 'undefined' === typeof validationPage) {
      navigate(ROLE_PUBLIC['home'])
    }
    window.sessionStorage.removeItem('lastCompanyCall')
  }, [validationPage])

  return (
    <Div cssClass='confirmation-page'>
      <h2 className='scene-title'>{title}</h2>
      <Div cssClass='home-text'>
        {renderHtml(description)}
      </Div>

      <Div cssClass='confirmation-buttons'>
        <Buttons buttons={[
          { cssClass: 'is-success confirmation-back-home is-rounded', callback: () => navigate(ROLE_PUBLIC['home']), text: t('actions.go_home') },
        ]} />
      </Div>
    </Div>
  )
}

ValidationPage.propTypes = {
  page: object
}

export default ValidationPage